import script from "./ChromakeyCaptions.vue?vue&type=script&setup=true&lang=js"
export * from "./ChromakeyCaptions.vue?vue&type=script&setup=true&lang=js"

import "./ChromakeyCaptions.vue?vue&type=style&index=0&id=1e9ccc08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e9ccc08"]])

export default __exports__